import Cache from "../services/Cache";
import h from "../helper/helper";
import * as Bluebird from "bluebird";
var cache = new Cache("blobs");
var uriToBlob = function (blob) {
    if (typeof blob === "string") {
        return h.dataURItoBlob(blob);
    }
    return blob;
};
var knownBlobUrls = {};
var blobCache = {
    store: function (blob) { return cache.store(blob.getBlobID(), blob.getMeta(), blob.getBlobData()).thenReturn(blob.toURL()); },
    readFileAsArrayBuffer: function (dir, name) { return Bluebird.reject("We are not on a device. Can't read file " + dir + " " + name); },
    moveFileToBlob: function (dir, name, blobID) { return Bluebird.reject("We are not on a device. Can't move file " + dir + " " + name + " (blobID: " + blobID + ")"); },
    getBlobUrl: function (blobID) {
        if (!knownBlobUrls[blobID]) {
            knownBlobUrls[blobID] = cache.get(blobID).then(function (data) {
                if (typeof data.blob === "undefined" || data.blob === false) {
                    throw new Error("cache invalid!");
                }
                return h.toUrl(uriToBlob(data.blob));
            });
        }
        return knownBlobUrls[blobID];
    },
    isLoaded: function (blobID) { return cache.contains(blobID); },
    clear: function () { return cache.deleteAll(); }
};
export default blobCache;



//////////////////
// WEBPACK FOOTER
// ./js/asset/blobCache.ts
// module id = bMcU
// module chunks = 1 2 3